export default "__VITE_ASSET__BrDiYxBD__"